import axios from 'axios';

import { getStrapiURL } from '../lib/api';
const apiBaseUrl = getStrapiURL();

import PressHighlights from '../components/shared/PressHighlights';
import BannerCard from '../components/shared/shared-card/BannerCard';
import SiteHeader from '../components/shared/SiteHeader';

const PreeHighlights = ({ pressHighlights, seo }) => {
  return (
    <>
      <SiteHeader
        title={seo?.MetaTitle}
        desc={seo?.MetaDescription}
        url={seo?.MetaUrl}
        image={seo?.image?.data?.attributes?.url}
      />
      <div className="container-default-1209px">
        <BannerCard
          title="AlmaBetter in News"
          desc="Find all our press coverages, awards and recognitions"
          textAlign="text-center"
          bgColor="bg-peach"
        />
        <PressHighlights pressHighlights={pressHighlights} title="Press releases" />
        {/* todo: add card */}
        {/* <h1>Awards and recognitions</h1> */}
      </div>
    </>
  );
};

export default PreeHighlights;

export async function getStaticProps(context) {
  try {
    const { data: pressHighlights } = await axios.get(
      `${apiBaseUrl}/api/press-hightlight?populate=highlights.image`
    );
    const { data } = await axios.get(`${apiBaseUrl}/api/global?populate=seo.image`);
    return {
      props: {
        pressHighlights: pressHighlights.data || {},
        seo: data.data.attributes.seo,
      },
      revalidate: 3600,
    };
  } catch (error) {
    return { props: { error } };
  }
}
